export default __webpack_public_path__ + "img/label.puroak.03.asset.9befe7bb.png";